import { render, staticRenderFns } from "./AllContacts.vue?vue&type=template&id=d97b3302&scoped=true"
import script from "./AllContacts.vue?vue&type=script&lang=js"
export * from "./AllContacts.vue?vue&type=script&lang=js"
import style0 from "./AllContacts.vue?vue&type=style&index=0&id=d97b3302&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d97b3302",
  null
  
)

export default component.exports